"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeObject = removeObject;
var _disposeMaterial = require("./disposeMaterial");
function removeObject(obj) {
  if (!obj) {
    return;
  }
  while (obj.children.length > 0) {
    removeObject(obj.children[0]);
    obj.remove(obj.children[0]);
  }
  if (obj.geometry) obj.geometry.dispose();
  if (obj.material) (0, _disposeMaterial.disposeMaterial)(obj.material);
}